import {
	Button,
	Popover,
	PopoverContent,
	PopoverTrigger,
	useDisclosure
} from "@heroui/react";
import {useMutation, useQueryClient} from '@tanstack/react-query';
import repositories from '../repositories.jsx';
import {useParams} from 'react-router-dom';
import toast from 'react-hot-toast';
import _ from 'lodash';

export default function VideoContentDeleteButton({children, speakers, data, onChange,onRemoved, ...props}) {
	const {ID} = useParams();
	const queryClient = useQueryClient();
	const {isOpen, onOpen, onOpenChange} = useDisclosure();
	
	const onValueChange = (value) => {
		if (typeof onChange === 'function') onChange(value)
	}
	
	const onSubmit = useMutation({
		mutationFn: repositories.project.deleteSrt,
		onSuccess: async () => {
			onRemoved(data?.index)
		},
		onError: (error) => {
			toast.error(error?.response?.data?.detail || 'Something went wrong')
		},
		onSettled: async () => {
			onOpenChange();
			onValueChange(false);
		},
	})

	const removeItemByIndex = () => {
		if (data?.voice) {
			onSubmit.mutate({
				project_id: ID,
				srt_id: data?.id,
			})
		}else{
			const updatedData = _.cloneDeep(props?.form?.values?.text_srt_json || []).filter((_, index) => index !== props?.segmentKey)
			props?.form.setFieldValue('text_srt_json', updatedData)
			setTimeout(async () => {
				await props?.form.setFieldValue('is_change_available', false)
			}, 500)
		}
	};
	
	return (
		<>
			<Popover
				placement="bottom-end"
				showArrow isOpen={isOpen}
				isDismissable backdrop="opaque"
				onOpenChange={(trigger) => {
					onOpenChange(trigger)
					onValueChange(!trigger)
				}}
				classNames={{
					content: "min-w-72 p-6"
				}}
			>
				<PopoverTrigger>
					<Button
						color="danger" variant="ghost" size="sm" isIconOnly radius="full"
						className="w-full overflow-hidden border-0 bg-red-500 bg-opacity-10"
					>
						<i className="hgi-stroke hgi-delete-01 text-xl"></i>
					</Button>
				</PopoverTrigger>
				<PopoverContent>
					<div className="text-center">
						<h4 className="mb-5 text-lg font-medium">Are you sure?</h4>
						<p className="mb-5">you want to delete this content?</p>
						<Button
							isLoading={onSubmit.isPending}
							onPress={removeItemByIndex}
							color="danger" variant="solid"
							radius="lg" fullWidth
						>
							Yes
						</Button>
					</div>
				</PopoverContent>
			</Popover>
		</>
	)
}
